import { TFieldVariety } from './isFieldVariety';

function getFieldVarieties(field: {
	varieties: Pick<TFieldVariety, 'name'>[];
}) {
	return field.varieties?.map((variety) => variety.name).join(', ') || '-';
}

export default getFieldVarieties;
